/* src/app/pages/examples/profilepage/components/form-contato/form-contato.component.scss */
:host {
  --mdc-outlined-text-field-disabled-input-text-color: red;
}
/*# sourceMappingURL=form-contato.component.css.map */
